<template>
<div class="custom-notiBox">
  <v-card class="tab-card">
  <h2>Notification settings</h2>
      <v-layout class="notificationbox">
          <div class="noti-box inner-notificationbox">
              <template>
                <v-card class="imagebox" outlined>
                  <div class="noti-innerBox">
                    <h3>Push Notification</h3>
                    <v-switch class="yellow_notify" @click="updatePushEmailNotify" v-model="push_notification"></v-switch>
                  </div>
                  <div class="noti-innerBox">
                    <h3>Email Notification</h3>
                    <v-switch class="yellow_notify" @click="updatePushEmailNotify" v-model="email_notification"></v-switch>
                  </div>
                </v-card> 
              </template>
          </div>
      </v-layout>
  </v-card>

</div>
</template>
<script>
  import { GET_REFERRAL_DETAIL } from "../../store/actions.type";
  import { isEmpty } from 'lodash';
  import ApiService from '@/api/api.service';
  export default {
    data: () => ({
      push_notification: true,
      email_notification:true,
    }),
    computed: {  
      isDataEmpty: function () {
        return isEmpty(this.$store.getters.getProfileDetail.data);
      },
    },
    mounted(){
      if(this.isDataEmpty){
        this.getReferralDetail();
      }else{
      }
    },
    unmounted(){
      this.getReferralDetail();
    },
    created(){
       let cognito_idp = atob(localStorage.getItem('cognito_idp'));
       ApiService.setHeader();
        ApiService.post('get-push-email-status-notification',{
          aws_cognito_id: cognito_idp,
        }).then( (response) => {
            this.push_notification = response.data.data.push_notification_status == "on" ? true:false;
            this.email_notification = response.data.data.email_notification_status == "on" ? true:false;
        })
    },
    methods:{
      updatePushEmailNotify(event){
        let user_name =  this.$store.getters.getUserDetails.user_name;
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        let push_status = (this.push_notification == true) ? "on":"off";
        let email_status = (this.email_notification == true) ? "on":"off";
        ApiService.setHeader();
        ApiService.post('update-push-email-status-notification',{
          aws_cognito_id: cognito_idp,
          push_notification_status: push_status,
          email_notification_status: email_status,
        }).then( (response) => {
            this.push_notification = response.data.data.push_notification_status == "on" ? true:false;
            this.email_status = response.data.data.email_notification_status == "on" ? true:false;
        })
      },
      getReferralDetail(){
          this.$store.dispatch(GET_REFERRAL_DETAIL, {
            data:{
              aws_cognito_id:atob(localStorage.getItem('cognito_idp')),
            },
            api:'get-referral-detail',
          }).then(()=>{
            let response = this.$store.getters.getReferralDetail.data
            if (this.$store.getters.getReferralDetail.status == 'error') {
              return [];
            }else{
            }
          })
          .catch(function (error) {
          });
        }
    },
  }
</script>

